import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'invoiceList': [],
};

export const order = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_ORDER_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.LOAD_ORDER_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'invoiceList': action.response.data,
      'loading': false,
    }),
    [ActionTypes.LOAD_ORDER_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'invoiceList': [],
      'loading': false,
    }),
  })(state, action);
};
